<template>
	<input
		:class="{
			input: true,
			input_valid: this.status === 'valid',
			input_invalid: this.status === 'invalid',
		}"
		:data-style="style"
		:status="status"
		:align="align"
		@change="handleChange"
		@input="handleInput"
	/>
</template>

<script>
	export default {
		name: "Input",
		props: {
			style: String,
			status: String,
			mask: String,
			align: String,
		},
		methods: {
			/* INIT FUNCTIONS */
			initMask() {
				const input = this.$el;

				if (this.mask == "phone") {
					this.placeholder = "+7 (___) ___-__-__";

					input.addEventListener("input", (event) => {
						let value = event.target.value.replace(/\D/g, "");
						if (value.length > 11) {
							value = value.substring(0, 11);
						}

						let formatted = "";

						if (!value) return (event.target.value = "");

						if (["7", "8", "9"].includes(value[0])) {
							if (value[0] === "9") value = "7" + value;
							formatted = "+7 ";

							if (value.length > 1) formatted += "(" + value.substring(1, 4);
							if (value.length >= 5) formatted += ") " + value.substring(4, 7);
							if (value.length >= 8) formatted += "-" + value.substring(7, 9);
							if (value.length >= 10) formatted += "-" + value.substring(9, 11);
						} else {
							formatted = "+" + value.substring(0, 16);
						}

						event.target.value = formatted;

						this.handleInput(event);
					});

					// Добавляем +7 при фокусе, если поле пустое
					input.addEventListener("focus", (e) => {
						if (!e.target.value) e.target.value = "+7 ";
					});

					// Убираем +7 при потере фокуса, если больше ничего не введено
					input.addEventListener("blur", (e) => {
						if (e.target.value === "+7 ") e.target.value = "";
					});
				}
			},

			/* EVENT HANDLERS */
			handleChange(event) {
				this.$emit("iptchange", event, event.target.value);
			},
			handleInput(event) {
				this.$emit("iptinput", event, event.target.value);
			},
		},
		mounted() {
			if (this.mask) this.initMask();
		},
	};
</script>

<style lang="scss">
	.input {
		height: 36px;
		width: 100%;
		padding-left: 12px;
		padding-right: 10px;
		font-family: "Avenir";
		font-size: 12px;
		border: 1px solid transparent;
		border-radius: 6px;
		background-color: $colorMainLight;
		box-shadow: $shadowLight;
		color: #222325;
		-webkit-text-fill-color: #222325;

		&[data-style="small"] {
			height: 26px;
			border-radius: 4px;
		}

		&:disabled {
			border: 1px solid #dcdcdc;
			box-shadow: none;
			-webkit-text-fill-color: #222325;
			opacity: 1;
		}

		&:focus {
			background-color: #fff;
		}

		&::placeholder {
			color: #9b9b9b;
		}

		&:-webkit-autofill,
		&:-webkit-autofill:hover,
		&:-webkit-autofill:focus {
			background-color: $colorMainLight;
			box-shadow: $shadowLight;
		}

		&[data-align="center"] {
			text-align: center;
			padding-left: 10px;
			padding-right: 10px;
		}

		&_valid {
			border-color: #41c6eb;
		}

		&_invalid {
			border-color: #ff8068;
		}
	}
</style>
